import { combineQueryShellStates } from '../../hooks/useQueryShellState';

/**
 * Revela o corpo da página em bloco na carga inicial.
 * Chrome (nav/header/FAB) fica fora deste wrapper.
 *
 * @param {object} props
 * @param {boolean} [props.ready] — se false, mostra fallback (preferido)
 * @param {{ showBlockingSkeleton?: boolean }[]} [props.shells] —
 *   estados de `useQueryShellState`; combina com `combineQueryShellStates`
 * @param {import('react').ReactNode} props.fallback — skeleton composto
 * @param {import('react').ReactNode} props.children
 * @param {string} [props.className]
 */
export function PageContentShell({
  ready,
  shells,
  fallback,
  children,
  className,
}) {
  const blocking =
    ready === false ||
    (Array.isArray(shells) &&
      shells.length > 0 &&
      combineQueryShellStates(...shells).showBlockingSkeleton);

  if (blocking) {
    return (
      <div className={className} data-testid="page-content-shell-skeleton">
        {fallback}
      </div>
    );
  }

  return (
    <div className={className} data-testid="page-content-shell-ready">
      {children}
    </div>
  );
}

export default PageContentShell;
